import { SetSendLabelPurchasedNotificationActionStep } from "@redotech/redo-flows-common/oms/actions";
import { useTranslation } from "@redotech/redo-i18n";
import { RedoToggle } from "@redotech/redo-web/arbiter-components/toggle/redo-toggle";
import { memo } from "react";
import { PartialWithRequiredType } from ".";

export const SendLabelPurchasedNotificationToggle = memo(
  function SendLabelPurchasedNotificationToggle({
    step,
    setStep,
  }: {
    step: PartialWithRequiredType<SetSendLabelPurchasedNotificationActionStep>;
    setStep: (
      step: PartialWithRequiredType<SetSendLabelPurchasedNotificationActionStep>,
    ) => void;
  }) {
    const { t } = useTranslation();
    return (
      <RedoToggle
        label={t("Enabled")}
        setValue={(value) =>
          setStep({ ...step, sendLabelPurchasedNotification: value })
        }
        size="xs"
        value={step.sendLabelPurchasedNotification ?? false}
      />
    );
  },
);
